import { TASK_NUMBER_SYSTEM } from "@repo/fhir-systems/identifiers";
// ============================================================
// Task number (human-facing sequential identifier — "MF-1")
// ============================================================
//
// The Task number is the human-facing identifier a user cites ("look at MF-42").
// It is a real, searchable FHIR Task.identifier — distinct from the FHIR Task.id
// UUID and from the internal stage-work-item key. Pure helpers only: this lib
// owns the system + read/write shape, so core TaskModel stays ignorant of it.
// Allocation (the counter I/O) lives in resolvers/task-number.resolver.ts; the
// stamp is a write in the stamp-task-number bot — numbering is not an intent,
// so it has no command handler.

/** FHIR identifier system for the human-facing Task number. */

/** The Task-number entry for a Task's `identifiers` collection. */
export function withTaskNumber(value: string): { system: string; value: string } {
  return { system: TASK_NUMBER_SYSTEM, value };
}

/**
 * Read the Task number from an identifier collection — accepts either the domain
 * `TaskModel.identifiers` or a raw FHIR `Task.identifier` array. Undefined if absent.
 */
export function taskNumber(
  identifiers: ReadonlyArray<{ system?: string; value?: string }> | undefined,
): string | undefined {
  return identifiers?.find((i) => i.system === TASK_NUMBER_SYSTEM)?.value;
}

export { TASK_NUMBER_SYSTEM };
